import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Télécharger / exporter — flèche descendante duotone */
export const DownloadIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Plateau menthe */}
      <path d="M4 17h16v3.5H4z" fill="var(--equiply-icon-bg)" />
      {/* Flèche */}
      <path d="M12 3v12M7 11l5 5 5-5" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      {/* Base */}
      <path d="M4 17h16M4 17v3.5h16V17" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
);
DownloadIcon.displayName = "DownloadIcon";
